if ( typeof ShippingNotice !== 'function' ) {

  // Free-shipping threshold is computed server-side and passed in via the
  // `data-free-shipping` attribute (see snippets/free-shipping-threshold.liquid,
  // the single source of truth mirroring the "General profile" delivery rules).

  class ShippingNotice extends HTMLElement {

    _message(key, fallback) {
      const messages = window.LabooI18n && window.LabooI18n.shipping;
      return (messages && messages[key]) || fallback;
    }

    _interpolate(template, values) {
      return String(template).replace(/{{\s*(\w+)\s*}}/g, function (_, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
      });
    }

    constructor() {
      super();
      this.init();
    }

    init() {

      const cartTotalCents = Number(this.getAttribute('data-cart-total'));

      const thresholdCents = Number(this.getAttribute('data-free-shipping'));

      if ( ! thresholdCents || thresholdCents <= 0 ) {
        const wrapper = this.closest('.cart-notice, .sidebar-widget');
        if ( wrapper ) wrapper.style.display = 'none';
        return;
      }

      const remainingCents = thresholdCents - cartTotalCents;

      const textEl = this.querySelector('[data-js-free-shipping-text]');
      const sliderEl = this.querySelector('[data-js-free-shipping-slider]');

      let progress = 0;

      if ( remainingCents > 0 ) {

        if ( textEl ) {
          const amount = this._format(remainingCents);
          textEl.innerHTML = this._interpolate(
            this._message('spendMoreHtml', 'Spend <strong>{{ amount }}</strong> more to reach free shipping'),
            { amount: amount }
          );
        }
        progress = Math.min(100, Math.max(0, (cartTotalCents / thresholdCents) * 100));
        this.setAttribute('data-state', 'progress');

      } else {

        if ( textEl ) {
          textEl.textContent = this._message('qualified', 'You have qualified for FREE delivery');
        }
        progress = 100;
        this.setAttribute('data-state', 'eligible');

      }

      if ( sliderEl ) {
        sliderEl.style.width = `${progress}%`;
      }

    }

    _localeFor(currency) {
      switch ( ( currency || '' ).toUpperCase() ) {
        case 'EUR': return 'de-DE';
        case 'SEK': return 'sv-SE';
        case 'DKK': return 'da-DK';
        case 'CZK': return 'cs-CZ';
        case 'HUF': return 'hu-HU';
        case 'PLN': return 'pl-PL';
        case 'RON': return 'ro-RO';
        case 'CHF': return 'de-CH';
        case 'GBP': return 'en-GB';
        case 'USD': return 'en-US';
        case 'AUD': return 'en-AU';
        case 'CAD': return 'en-CA';
        case 'NZD': return 'en-NZ';
        case 'SGD': return 'en-SG';
        case 'AED': return 'en-AE';
        default: return 'en';
      }
    }

    _format(cents) {
      const currency = this.getAttribute('data-currency-code') || 'EUR';
      const value = Number(cents) || 0;

      try {
        return new Intl.NumberFormat(this._localeFor(currency), {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value / 100);
      } catch ( e ) {
        return ( value / 100 ).toFixed(2);
      }
    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
